import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetListOutcomesDomain = (state) =>
  state.get("widgetListOutcomesV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectWidgetListOutcomesDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDimensionsOutcomes = () =>
  createSelector(selectWidgetListOutcomesDomain, (state) =>
    state.get("dimensionsOutcomes")
  )

const makeSelectWidgetListOutcomes = () =>
  createSelector(selectWidgetListOutcomesDomain, (substate) => substate.toJS())

export default makeSelectWidgetListOutcomes
export { selectWidgetListOutcomesDomain }
